import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FactAdder from '../../../DataView/FactsEditor/FactsEditorToolbar/components/FactAdder';
import Modal from '@/components/molecules/Modals/SettingsModal';
import { BoundingBox } from '@/types';

interface FactAdderModalProps {
  docId: string;
  isOpen: boolean;
  onSuccess: VoidFunction;
  onClose: (bool: boolean) => void;
  selectedText?: string;
  highlightAreas?: BoundingBox[];
  caseId: string;
}

const FactAdderModal = ({
  docId,
  isOpen,
  onSuccess,
  onClose,
  selectedText,
  highlightAreas,
  caseId,
}: FactAdderModalProps) => {
  return (
    <Modal
      title={
        <div className="flex items-center gap-2 font-semibold text-blue-500">
          <FontAwesomeIcon icon={faPlusCircle} className="" />
          Add Fact
        </div>
      }
      content={
        <FactAdder
          docs={[]}
          handleNewFactCreated={onSuccess}
          docId={docId}
          caseId={caseId}
          sourceText={selectedText}
          highlightAreas={highlightAreas}
        />
      }
      isOpen={isOpen}
      size="small"
      handleClose={() => onClose(false)}
    />
  );
};

export default FactAdderModal;
